// src/index.js

import React from 'react';
import ReactDOM from 'react-dom/client';  // Cambié la importación para utilizar el nuevo método
import './index.css';  // El archivo de estilos globales
import App from './App';  // Importa el componente principal (App)
import reportWebVitals from './reportWebVitals';  // Si necesitas medir el rendimiento

// Se obtiene el contenedor de 'root' en el HTML y se renderiza la aplicación
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <App />  {/* Renderiza el componente principal de la aplicación */}
  </React.StrictMode>
);

// Si deseas comenzar a medir el rendimiento de tu aplicación, pasa una función a reportWebVitals.
reportWebVitals();
